module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/033-saint-kitts-and-nevis-9043ad942ba422bbae416c5528bc19b8.svg";